const TZ = "Asia/Kuala_Lumpur";

export function formatRM(sen) {
  if (sen == null) return "Not available";
  const amount = Number(sen) / 100;
  return `RM ${amount.toLocaleString("en-MY", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatDate(value) {
  if (!value) return "—";
  const date = new Date(value.length === 10 ? `${value}T00:00:00+08:00` : value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: TZ,
  }).format(date);
}

export function formatDateTime(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return `${formatDate(value)}, ${new Intl.DateTimeFormat("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: TZ,
  }).format(date)} MYT`;
}

export function formatNumber(value) {
  if (value == null) return "—";
  return Number(value).toLocaleString("en-MY");
}

export function formatBytes(bytes) {
  if (bytes == null) return "—";
  const units = ["B", "KB", "MB", "GB"];
  let value = Number(bytes);
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toFixed(value < 10 && unit > 0 ? 1 : 0)} ${units[unit]}`;
}

export function todayKL() {
  return new Intl.DateTimeFormat("en-CA", { timeZone: TZ }).format(new Date());
}

export const METRIC_LABELS = {
  reach: "Reach",
  views: "Views",
  likes: "Likes",
  comments: "Comments",
  shares: "Shares",
  saves: "Saves",
};

export const METRIC_KEYS = Object.keys(METRIC_LABELS);

/**
 * Each platform shows a different set of numbers under its own names. The stored fields never
 * change — only the labels and which fields are worth asking for.
 */
const PLATFORM_METRICS = {
  Instagram: {
    keys: ["reach", "views", "likes", "comments", "shares", "saves"],
    labels: { views: "Plays / Views", saves: "Saves" },
    hints: { reach: "Accounts reached" },
  },
  XiaoHongShu: {
    keys: ["views", "likes", "saves", "comments", "shares"],
    labels: { views: "Impressions (浏览量)", saves: "Collects (收藏)", shares: "Shares (分享)" },
    hints: {
      views: "XiaoHongShu reports impressions, not reach",
      saves: "Stored as Saves so it totals with the other platforms",
    },
  },
  TikTok: {
    keys: ["reach", "views", "likes", "comments", "shares", "saves"],
    labels: { views: "Video views", saves: "Saves" },
    hints: { reach: "Unique viewers, if shown" },
  },
  Threads: {
    keys: ["views", "likes", "comments", "shares"],
    labels: { views: "Views", comments: "Replies", shares: "Reposts" },
    hints: { views: "Threads does not report reach or saves" },
  },
};

export function metricsForPlatform(platform) {
  const config = PLATFORM_METRICS[platform];
  const keys = config?.keys || METRIC_KEYS;
  return keys.map((key) => ({
    key,
    label: config?.labels?.[key] || METRIC_LABELS[key],
    hint: config?.hints?.[key],
  }));
}

export const PLATFORM_METRIC_NOTE =
  "On XiaoHongShu, Saves are the post's Collects (收藏) and reach is not reported by the platform.";

export function metricCoverage(metric) {
  if (!metric || metric.value == null) return "Not available";
  return `reported for ${metric.reported_posts} of ${metric.total_posts} published post${
    metric.total_posts === 1 ? "" : "s"
  }`;
}
